/**
 * "Ver más" / "Ver menos" toggle for icon-list block.
 */
(function () {
	'use strict';

	console.log('view.js de icon-list');

	function init() {
		const verMasButton = document.querySelector('.b-icon-list__ver-mas');

		if(verMasButton) {
			verMasButton.addEventListener('click', function (e) {
				e.preventDefault();
				const blockContainer = this.closest('.b-icon-list');
				const listContainer = blockContainer.querySelector('.b-icon-list__items');
				const isExpanded = listContainer.getAttribute('aria-expanded') === 'true';

				console.log(listContainer);

				//toggle aria-expanded in listContainer
				listContainer.setAttribute('aria-expanded', !isExpanded);
				blockContainer.querySelectorAll('.b-icon-list__ver-mas span')
				.forEach(function (span) {
					span.classList.toggle('js-hidden');
				});

			});
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
